import { SET_EDIT_PANEL, CLEAR_EDIT_PANEL, SET_PANEL_COUNT } from "../types";

export const setEditPanel = (data) => ({
    type: SET_EDIT_PANEL,
    payload: data,
});

export const setPanelCount = (count) => ({
    type: SET_PANEL_COUNT,
    payload: count,
})

export const clearEditPanel = () => ({
    type: CLEAR_EDIT_PANEL,
});
